import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/payjet_logo_neu__white_quadratisch.png'
import _imports_1 from '@/assets/user-regular-grey.svg'


const _hoisted_1 = { class: "fixed inset-0 flex z-40" }
const _hoisted_2 = { class: "absolute top-0 right-0 -mr-12 pt-4" }
const _hoisted_3 = { class: "pt-5 pb-4" }
const _hoisted_4 = {
  "aria-label": "Sidebar",
  class: "mt-5"
}
const _hoisted_5 = { class: "px-2 space-y-1" }
const _hoisted_6 = { class: "flex-shrink-0 flex border-t border-gray-200 p-4" }
const _hoisted_7 = {
  class: "flex-shrink-0 group block",
  href: "#"
}
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "ml-3" }
const _hoisted_10 = { class: "lg:hidden" }
const _hoisted_11 = { class: "bg-indigo-600 py-2 px-4 flex items-center justify-between sm:px-6 lg:px-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!
  const _component_MenuIcon = _resolveComponent("MenuIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TransitionRoot, {
      show: _ctx.mobileMenuOpen,
      as: "template"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          class: "relative z-40 lg:hidden",
          onClose: _ctx.closeMobileMenu
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TransitionChild, {
              show: _ctx.mobileMenuOpen,
              as: "template",
              enter: "transition-opacity ease-linear duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "transition-opacity ease-linear duration-300",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "fixed inset-0 bg-gray-600 bg-opacity-75" }, null, -1)
              ]))]),
              _: 1
            }, 8, ["show"]),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "transition ease-in-out duration-300 transform",
                "enter-from": "-translate-x-full",
                "enter-to": "translate-x-0",
                leave: "transition ease-in-out duration-300 transform",
                "leave-from": "translate-x-0",
                "leave-to": "-translate-x-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogPanel, { class: "relative flex-1 flex flex-col max-w-xs w-full bg-white focus:outline-none" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_TransitionChild, {
                        as: "template",
                        enter: "ease-in-out duration-300",
                        "enter-from": "opacity-0",
                        "enter-to": "opacity-100",
                        leave: "ease-in-out duration-300",
                        "leave-from": "opacity-100",
                        "leave-to": "opacity-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("button", {
                              class: "ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",
                              type: "button",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeMobileMenu && _ctx.closeMobileMenu(...args)))
                            }, [
                              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1)),
                              _createVNode(_component_XIcon, {
                                "aria-hidden": "true",
                                class: "h-6 w-6 text-white"
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_3, [
                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-shrink-0 flex items-center px-4" }, [
                          _createElementVNode("img", {
                            alt: "Workflow",
                            class: "h-8 w-auto",
                            src: _imports_0
                          })
                        ], -1)),
                        _createElementVNode("nav", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (item) => {
                              return (_openBlock(), _createBlock(_component_router_link, {
                                key: item.name,
                                to: { name: item.name },
                                class: "group p-2 rounded-md flex items-center text-base font-medium text-gray-600 hover:bg-gray-200 hover:text-gray-900"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                    "aria-hidden": "true",
                                    class: "mr-4 h-6 w-6"
                                  })),
                                  _createTextVNode(" " + _toDisplayString(item.meta.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("a", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _cache[6] || (_cache[6] = _createElementVNode("div", null, [
                              _createElementVNode("img", {
                                alt: "",
                                class: "w-6 h-6 opacity-60",
                                src: _imports_1
                              })
                            ], -1)),
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("p", {
                                class: "text-sm font-medium text-gray-500 group-hover:text-gray-700",
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                              }, "Logout")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _cache[7] || (_cache[7] = _createElementVNode("div", {
                "aria-hidden": "true",
                class: "flex-shrink-0 w-14"
              }, null, -1))
            ])
          ]),
          _: 1
        }, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _cache[9] || (_cache[9] = _createElementVNode("div", null, [
          _createElementVNode("img", {
            alt: "Workflow",
            class: "h-8 w-auto",
            src: _imports_0
          })
        ], -1)),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "-mr-3 h-12 w-12 inline-flex items-center justify-center bg-indigo-600 rounded-md text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",
            type: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openMobileMenu && _ctx.openMobileMenu(...args)))
          }, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "sr-only" }, "Sidebar öffnen", -1)),
            _createVNode(_component_MenuIcon, {
              "aria-hidden": "true",
              class: "h-6 w-6"
            })
          ])
        ])
      ])
    ])
  ], 64))
}